import { ComponentProps } from "react";

/*
 * Icons the flow draws that the Figma set does not have. Outlines in currentColor, no ids, no
 * clip paths: a duplicated id from a Figma icon breaks every later copy in Safari.
 */

/** ✦: suggested by AI. The star sits in the middle of its box, so it centres on a line of text. */
export const CreateAdV2SparkleIcon = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 5l1.8 5.2L19 12l-5.2 1.8L12 19l-1.8-5.2L5 12l5.2-1.8z" />
  </svg>
);

/** Up and down arrows: the photos can be dragged into another order. */
export const CreateAdV2DragIcon = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 7l4-4 4 4M8 17l4 4 4-4M12 3v18" />
  </svg>
);

/** A crossed-out signal: no connection. */
export const CreateAdV2OfflineIcon = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2 8.8a15 15 0 0 1 4.2-2.6M9.8 5.2A15 15 0 0 1 22 8.8M5 12.6a10 10 0 0 1 4-2.2M15.5 10.8A10 10 0 0 1 19 12.6M8.5 16.2a5 5 0 0 1 7 0M12 20h.01M3 3l18 18" />
  </svg>
);

/** A line still to come on the reading checklist. */
export const CreateAdV2PendingIcon = (props: ComponentProps<"svg">) => (
  <svg viewBox="0 0 12 12" fill="none" {...props}>
    <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth={2} />
  </svg>
);

/** A lightning bolt: a boost puts the ad first. */
export const CreateAdV2BoltIcon = (props: ComponentProps<"svg">) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
  </svg>
);
